import { render, staticRenderFns } from "./rightBot.vue?vue&type=template&id=e6ef60a6&scoped=true&"
import script from "./rightBot.vue?vue&type=script&lang=js&"
export * from "./rightBot.vue?vue&type=script&lang=js&"
import style0 from "./rightBot.vue?vue&type=style&index=0&id=e6ef60a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ef60a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6ef60a6')) {
      api.createRecord('e6ef60a6', component.options)
    } else {
      api.reload('e6ef60a6', component.options)
    }
    module.hot.accept("./rightBot.vue?vue&type=template&id=e6ef60a6&scoped=true&", function () {
      api.rerender('e6ef60a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/zhwlDrawer_N/rightBar/rightBot.vue"
export default component.exports